/**
 * `/agents/new` — a legacy route. Creating AND editing a custom agent happen
 * in the "Build your own agent" popup on /agents (BuilderWizardPopup); this
 * page only forwards there: `?edit=<definition_id>` opens the popup on that
 * agent, anything else opens it empty.
 */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AgentBuilder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editId = new URLSearchParams(location.search).get('edit') || null;

  useEffect(() => {
    navigate('/agents', { replace: true, state: { openWizard: true, editId } });
  }, [navigate, editId]);

  return null;
};

export default AgentBuilder;
